import { useState } from 'react';

export default function SubscribeSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = () => {
    const value = email.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setStatus('error');
      setMessage('请输入有效的邮箱地址，方便有新实锤时提醒你。');
      return;
    }
    setStatus('success');
    setMessage('已加入收藏提醒列表。演示页面不会真实发送邮件，随时可以回来查看更新。');
    setEmail('');
  };

  return (
    <section id="subscribe" className="w-full bg-background-100 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-10">
        <div className="w-full rounded-lg overflow-hidden border border-primary-800 bg-primary-900 relative">
          <div className="absolute inset-0 opacity-20">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20dark%20green%20archival%20texture%20with%20layered%20paper%20edges%2C%20faint%20grid%20lines%20and%20warm%20amber%20light%20streaks%2C%20minimal%20editorial%20background%20art%2C%20no%20text%2C%20subtle%20depth%20and%20grain&width=1600&height=700&seq=gt-subscribe-bg&orientation=landscape"
              alt="瓜田黑料证据存档背景纹理"
              title="瓜田黑料 · 证据存档持续更新"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 p-6 md:p-10 lg:p-12">
            <div className="lg:col-span-6">
              <span className="inline-flex items-center gap-2 text-xs tracking-[0.2em] text-primary-200">
                <span className="w-6 h-px bg-accent-400" />
                Save The Evidence
              </span>
              <h2 className="mt-4 text-2xl md:text-4xl font-bold leading-snug text-background-50">
                收藏这一页，随时回来对线
              </h2>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-primary-100/85">
                瓜田黑料实锤证据会持续补录，时间线锤上的节点也会一直往后延。
                留下邮箱，有新内容入库时第一时间收到提醒，不用再翻收藏夹找。
              </p>

              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="填一个常用的邮箱地址"
                  className="w-full sm:flex-1 rounded-md border border-primary-600 bg-primary-950/50 px-4 py-3 text-sm text-background-50 placeholder:text-primary-200/60 focus:outline-none focus:border-accent-400 focus:ring-2 focus:ring-accent-500/30"
                />
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="px-6 py-3 rounded-md bg-accent-500 text-background-50 text-sm hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
                >
                  <i className="ri-notification-3-line" />
                  订阅更新
                </button>
              </div>

              {message ? (
                <p
                  className={`mt-3 text-xs md:text-sm ${
                    status === 'success' ? 'text-primary-200' : 'text-accent-200'
                  }`}
                >
                  {message}
                </p>
              ) : null}
            </div>

            <div className="lg:col-span-6 flex flex-col justify-center gap-4">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {[
                  { icon: 'ri-lock-2-line', title: '原档不覆盖', desc: '新内容只新增副本，旧证据原样保留。' },
                  { icon: 'ri-fingerprint-line', title: '哈希可校验', desc: '每个文件都留指纹，改没改一查便知。' },
                  { icon: 'ri-time-line', title: '节点可追溯', desc: '时间线锤记录每一次补录与修正。' },
                ].map((card) => (
                  <div
                    key={card.title}
                    className="rounded-lg border border-primary-700/60 bg-primary-950/40 p-4"
                  >
                    <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500/20 text-accent-200 text-lg">
                      <i className={card.icon} />
                    </span>
                    <p className="mt-3 text-sm font-medium text-background-50">{card.title}</p>
                    <p className="mt-1 text-xs leading-relaxed text-primary-100/70">{card.desc}</p>
                  </div>
                ))}
              </div>

              <div className="flex flex-wrap items-center gap-4 rounded-lg border border-primary-700/60 bg-primary-950/40 px-4 py-4">
                <div className="flex items-center gap-2 text-sm text-primary-100/85">
                  <i className="ri-group-line text-accent-300" />
                  47,900 人正在对线
                </div>
                <div className="flex items-center gap-2 text-sm text-primary-100/85">
                  <i className="ri-database-2-line text-accent-300" />
                  12,480 份证据在库
                </div>
                <div className="flex items-center gap-2 text-sm text-primary-100/85">
                  <i className="ri-calendar-check-line text-accent-300" />
                  每日 08:00 更新
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}